import { JavaApiAdapterService } from '@/app/common/apiadapter/javaapi.service';
import { CommonService } from '@/app/common/common.service';
import { User } from '@/app/common/model/user';
import { PopUpService } from '@/app/common/popup/popup.service';
import { CacheService } from '@/app/common/service/cache.service';
import { PolicyTypeEnum, ValidationService } from '@/app/common/service/validation.service';
import angular, { IQService, ISCEService, ITimeoutService } from 'angular';
import { AuthenticationService } from '@app/authentication/services/authentication.service';
import { IAppRootScopeService } from '@/app/app.definition';

let auth = '';
export class PasswordResetController {
    questions: any;
    codeRequired: boolean;
    stateName: string;
    token: string;
    user: User;
    validating: boolean;
    showLoader: any;
    $validationProvider: any;
    newSecQ: { "id": number, "answer": string, "answerAgain": string }
    vkPolicyTooltip: string = "";
    vkErrorMsg: string = "";
    hasVkError: boolean = false;

    static $inject = ["$q", "CommonService", "$location", "$rootScope", "$state", "PopUpService", "ApiAdapterService", "$injector", "CacheService", "ValidationService", "$sce", "$timeout", "AuthenticationService", "ecareEnv"];
    expiredPassReset: boolean;
    expiredPassResetError: any;

    constructor(
        private $q: IQService,
        private $_common: CommonService,
        private $location: ng.ILocationService,
        private $rootScope: IAppRootScopeService,
        private $state: ng.ui.IStateService,
        private $_pop: PopUpService,
        private $_api: JavaApiAdapterService,
        private $injector: ng.auto.IInjectorService,
        private $_cache: CacheService,
        private ValidationService: ValidationService,
        private $sce: ISCEService,
        private $timeout: ITimeoutService,
        private AuthenticationService: AuthenticationService,
        private ecareEnv: string) {

        this.$validationProvider = $injector.get('$validation');
        $rootScope.mainShowLoader = false;
        $rootScope.rootShowLoader = false;
        this.expiredPassReset = false;

        this.newSecQ = { "id": null, "answer": null, "answerAgain": null }

        // Populate User form from what we have stored
        // this.user = this.$_user.getMe();
        this.codeRequired = true;

        let locSrch = $location.search();

        if (!!locSrch.token && !!locSrch.code) {
            $_cache.setToken(locSrch.token);
            $_cache.setVKResetCode(locSrch.code);
            console.log("token: " + locSrch.token);
            let token = locSrch.token;
            let code = $_cache.getVKResetCode();
            let u = new User().deserialize({ token: token, code: code });

            console.log("user with token: ", u);

            this.showLoader = true;

            $_api.getVKResetInfo(u).then(
                (s: User) => {
                    this.ecareEnv != 'my' && console.log("resetToken:", token, 'resetCode:', $_cache.getVKResetCode(), 'user:', s.providerIdentity);
                    this.user = s;
                    $_api.getValidationPolicy(this.user.providerIdentity, null, PolicyTypeEnum.VAULT_KEY_POLICY, "").then((policies) => {
                        this.ValidationService.setAndProcessPolicy(PolicyTypeEnum.RESET_VAULT_KEY_POLICY, policies.resetVaultKeyPolicy);
                        this.ValidationService.setAndProcessPolicy(PolicyTypeEnum.VAULT_KEY_POLICY, policies.vaultKeyPolicy);
                        this.vkPolicyTooltip = this.ValidationService.getHtmlTooltip(PolicyTypeEnum.VAULT_KEY_POLICY);
                        this.vkErrorMsg = this.ValidationService.getPwdErrMessage(PolicyTypeEnum.VAULT_KEY_POLICY);
                        $sce.trustAsHtml(this.vkPolicyTooltip);
                    });
                },
                e => {
                    let snackbarObj = { snackbar: null };

                    console.log('Failed to get reset info:', e);

                    if (e == 'USED' || e == 'EXPIRED') {
                        snackbarObj.snackbar = 'VK_RESET_' + e;
                    }

                    this.goToLogin(snackbarObj);
                }
            ).finally(
                () => (this.showLoader = false)
            );

        } else {
            this.goToLogin({ snackbar: 'VK_RESET_NO_INFO' });
        }

        this.stateName = $state.current.name;
    }

    isValidVaultKey = (form) => {
        const isValid = this.ValidationService.isValidValue(PolicyTypeEnum.VAULT_KEY_POLICY, this.user.password);
        this.hasVkError = !isValid;
        form.password.$setValidity('custom', isValid);
        return isValid;
    };
    // On clicking proceed
    proceed = (form, role) => {
        const deferred = this.$q.defer();
        this.validating = true;
        this.showLoader = true;
        const that = this;
        if (!this.isValidVaultKey(form)) {
            this.showLoader = false;
            that.validating = false;
            this.$validationProvider.validate(form);
            this.$timeout(() => {
                $('#newVaultKey').focus();
            }, 0);
            deferred.reject();
            return deferred.promise;
        }
        this.$validationProvider.validate(form)
            .success(() => {
                if (that.user.password != that.user.cPassword) {
                    that.validating = that.showLoader = false;
                    that.$_pop.openInformationModal('Vault Keys do not match.');
                    deferred.reject();
                    return deferred.promise;
                }

                const pwrUser: User = new User();

                pwrUser.id = that.user.id;
                pwrUser.password = that.$_common.hashPassword(that.user.password);
                pwrUser.token = that.$_cache.getToken();
                pwrUser.code = that.$_cache.getVKResetCode();

                that.$_api.doBackupPasswordReset(pwrUser).then(
                    (s) => {
                        that.validating = that.showLoader = false;
                        that.goToLogin({ snackbar: 'VK_RESET_SUCCESS' });
                        deferred.resolve();
                    },
                    (e) => {
                        that.validating = that.showLoader = false;
                        console.log("exception");
                        console.log(e);

                        if (e.toString().indexOf('Api not instantiated') != -1) {
                            this.goToLogin({ snackbar: 'API_NOT_AVAILABLE' });
                        } else {
                            this.expiredPassResetError = e;
                            this.expiredPassReset = true;
                            //this.goToLogin({snackbar:'VK_RESET_FAILURE'});
                        }
                        deferred.reject();
                    });
            })
            .error(function (message) {
                that.showLoader = false;
                that.$rootScope.mainShowLoader = false;
                that.validating = false;
                console.log("Validation Error:", message);
                deferred.reject();
            });
        return deferred.promise;
    };

    // redirect to login page

    goToLogin = (params?) => {
        this.expiredPassReset = false;
        this.$_cache.setToken(null);
        this.$location.search('snackbar', params.snackbar || null);
        this.$state.go("login");
        this.AuthenticationService.init();
    }
}


angular.module('eCareVault.authentication')
    .controller('PasswordResetController', PasswordResetController);
